import React from 'react';
import './Toolbar.css';

function Toolbar({ 
  onUndo, 
  onRedo, 
  onGridToggle, 
  showGrid, 
  zoomLevel, 
  onZoomIn, 
  onZoomOut,
  uiScale,
  onUiScaleChange,
  canUndo,
  canRedo
}) {
  // UI 스케일 옵션
  const scaleOptions = [0.8, 1, 1.2, 1.5, 2.0];

  return (
    <div className="toolbar">
      <div className="toolbar-group">
        <button className="toolbar-button" title="파일">File</button>
        <button 
          className={`toolbar-button ${!canUndo ? 'disabled' : ''}`} 
          title="실행 취소 (Ctrl+Z)"
          onClick={onUndo}
          disabled={!canUndo}
        >
          ⟲
        </button>
        <button 
          className={`toolbar-button ${!canRedo ? 'disabled' : ''}`} 
          title="다시 실행 (Ctrl+Y)"
          onClick={onRedo}
          disabled={!canRedo}
        >
          ⟳
        </button>
      </div>
      
      <div className="toolbar-group">
        <button 
          className={`toolbar-button ${showGrid ? 'active' : ''}`} 
          title="그리드 표시/숨기기"
          onClick={onGridToggle}
        >
          #
        </button>
      </div>
      
      <div className="toolbar-group">
        <button className="toolbar-button" title="축소" onClick={onZoomOut}>−</button>
        <span className="zoom-display">{Math.round(zoomLevel * 100)}%</span>
        <button className="toolbar-button" title="확대" onClick={onZoomIn}>+</button>
      </div>
      
      <div className="toolbar-group">
        <span className="scale-label">UI 크기:</span>
        <select 
          className="scale-select"
          value={uiScale}
          onChange={(e) => onUiScaleChange(parseFloat(e.target.value))}
        >
          {scaleOptions.map(scale => (
            <option key={scale} value={scale}>
              {Math.round(scale * 100)}%
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default Toolbar;